import {ValidationUtils} from "../../../../utils/Utils";

export const isTargetStatusNotNull = (inStationPkgStatusReasonMapping, onRoadPkgStatusReasonMapping) => {
    return Boolean(ValidationUtils.isNotEmptyObject(inStationPkgStatusReasonMapping)
        || ValidationUtils.isNotEmptyObject(onRoadPkgStatusReasonMapping))
}